import { useState } from "react";

export interface ContactFormData {
  email: string;
  mobile: string;
  message: string;
}

const CONTACT_FORM_API_URL =
  "https://api.grasslandsmarkets.com/private/contactForm";

export const useContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const sendMessage = async (data: ContactFormData) => {
    setLoading(true);
    setError(false);
    try {
      const response = await fetch(CONTACT_FORM_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            email: data.email,
            // Hyphens are only for the user's readability; the backend
            // expects a plain digit string.
            phoneNumber: data.mobile.replace(/-/g, ""),
            message: data.message,
          },
        }),
      });

      if (!response.ok) {
        setError(true);
        return { success: false };
      }

      return { success: true };
    } catch (err) {
      console.error(err);
      setError(true);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    sendMessage,
  };
};
